import { useContext } from 'react';
import { ToastContext, type ToastApi } from './toast-context';

export function useToast(): ToastApi {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    return {
      show: (body) => {
        if (typeof window !== 'undefined') {
          console.info('[toast]', body);
        }
      },
      dismiss: () => undefined,
    };
  }
  return ctx;
}
